// extracted by mini-css-extract-plugin
module.exports = {"location-container--header":"R9Z7y","body":"KfTCA","body-art":"aW5Vn","rc-tabs-bar":"AltZr","rc-tabs-tab":"PG0xO","rc-tabs-tab-active":"_0XET6","empty":"jOQKF","message":"_5MRoq"};